(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eco-catalog-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  if(!(event.target instanceof Element))return;
  document.querySelectorAll('.eco-catalog-drawer[open]').forEach(function(drawer){
    if(event.target.closest('.eco-catalog-close')){drawer.open=false;drawer.querySelector('summary').focus();}
    else if(!drawer.contains(event.target)){drawer.open=false;}
  });
});
document.addEventListener('keydown',function(event){
  if(event.key!=='Escape')return;
  const drawer=event.target instanceof Element?event.target.closest('.eco-catalog-drawer[open]'):null;
  if(drawer){drawer.open=false;drawer.querySelector('summary').focus();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["iu-registration-tracking"] && !Shopify.designMode) return;
  try {
    /* IngroUnico registration publisher. No Meta SDK, PageView or approval mutation. */
(async function(){
'use strict';
if(window.Shopify?.shop!=='amhfc5-0w.myshopify.com'||window.__iguRegistrationLoaded)return;
window.__iguRegistrationLoaded=true;
const DAY=86400000, SOURCE='igu:campaign:v1', PENDING='igu:application:v1:', DONE='igu:application:sent:v1:';
const consent=()=>window.Shopify?.customerPrivacy?.marketingAllowed?.()===true&&window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
const read=k=>{try{return JSON.parse(localStorage.getItem(k));}catch{return null;}};
const save=(k,v)=>{try{localStorage.setItem(k,JSON.stringify(v));return true;}catch{return false;}};
let current=null,busy=false,ticks=0,timer;
function source(){const p=new URLSearchParams(location.search);if(p.get('utm_source')==='facebook'&&p.get('utm_medium')==='paid_social'&&p.get('utm_campaign')==='igu_luce_campania_14d'&&['video_a','image_b'].includes(p.get('utm_content'))){const value={source:'facebook',medium:'paid_social',campaign:'igu_luce_campania_14d',creative:p.get('utm_content'),at:Date.now()};save(SOURCE,value);return value;}const old=read(SOURCE);return old&&Date.now()>=old.at&&Date.now()-old.at<=7*DAY?old:null;}
async function state(){const u=new URL(window.Shopify.routes?.root||'/',location.origin);u.searchParams.set('section_id','iu-registration-state');u.searchParams.set('_igu',String(Date.now()));const r=await fetch(u,{credentials:'same-origin',cache:'no-store'});if(!r.ok)return null;const doc=new DOMParser().parseFromString(await r.text(),'text/html');const n=doc.querySelector('[data-igu-registration-state]');return n?JSON.parse(n.textContent):null;}
async function process(s,src){
 if(!consent()||!s||s.shop!=='amhfc5-0w.myshopify.com'||!s.customer||s.blocked)return;
 const key=PENDING+s.customer,done=DONE+s.customer,p=read(key);
 if(read(done))return;
 if(!s.submitted){if(s.allowed)return;if(!p||p.customer!==s.customer||Date.now()-p.at>DAY)save(key,{customer:s.customer,at:Date.now(),source:src});return;}
 if(!p||p.customer!==s.customer||Date.now()<p.at||Date.now()-p.at>DAY)return;
 if(typeof window.Shopify.analytics?.publish!=='function')return;
 const hash=Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(s.shop+':1155764:'+s.customer)))).map(b=>b.toString(16).padStart(2,'0')).join('');
 const emit=()=>{if(!consent()||read(done))return;if(!save(done,{at:Date.now()}))return;const a=p.source;window.Shopify.analytics.publish('igu_business_application_submitted',{event_id:'igu-reg-'+hash,form_id:'1155764',registration_stage:'application_submitted',attribution:a?{source:a.source,medium:a.medium,campaign:a.campaign,creative:a.creative}:{source:'unattributed'}});try{localStorage.removeItem(key);}catch{}};
 if(navigator.locks)await navigator.locks.request('igu-registration-'+hash,emit);else emit();
}
async function tick(){if(busy||!consent())return;busy=true;try{const src=source();if(location.pathname.includes('/pages/illuminazione-materiale-elettrico-ingrosso'))return;current=await state();await process(current,src);if(current?.submitted||!current?.customer||++ticks>=180)clearInterval(timer);}catch{}finally{busy=false;}}
function start(){if(!consent())return;if(location.pathname.includes('/pages/illuminazione-materiale-elettrico-ingrosso')){source();return;}tick();if(!timer)timer=setInterval(tick,10000);}
document.addEventListener('visitorConsentCollected',()=>{if(consent())start();else{clearInterval(timer);timer=null;try{localStorage.removeItem(SOURCE);for(const k of Object.keys(localStorage))if(k.startsWith(PENDING))localStorage.removeItem(k);}catch{}}});
if(window.Shopify.customerPrivacy)start();else window.Shopify.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)start();});
})();
  } catch(e) { console.error(e); }
})();

})();
